/* tslint:disable */
import {
  CategoryRotation,
  ScreenCategory,
  PlayerGroup,
  RotationItem
} from '../index';

declare var Object: any;
export interface ScheduleTimeframeInterface {
  "id": string;
  "name"?: string;
  "start": Date;
  "end"?: Date;
  "inverse"?: boolean;
  "hasEnd"?: boolean;
  "repeat"?: boolean;
  "repeatDays"?: any;
  "repeatFrequency"?: number;
  "specificDates"?: any;
  "specificTime"?: boolean;
  "startTime"?: Date;
  "endTime"?: Date;
  "playMode"?: string;
  "minTimeBetweenPlays"?: number;
  "forceInterrupt"?: boolean;
  "forcePlayTime"?: number;
  "categoryRotationId"?: string;
  "screenCategoryId"?: string;
  "playerGroupId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "scheduleRotationId"?: string;
  "rotationItemId"?: string;
  categoryRotation?: CategoryRotation;
  screenCategory?: ScreenCategory;
  playerGroup?: PlayerGroup;
  rotationItem?: RotationItem;
}

export class ScheduleTimeframe implements ScheduleTimeframeInterface {
  "id": string;
  "name": string;
  "start": Date;
  "end": Date;
  "inverse": boolean;
  "hasEnd": boolean;
  "repeat": boolean;
  "repeatDays": any;
  "repeatFrequency": number;
  "specificDates": any;
  "specificTime": boolean;
  "startTime": Date;
  "endTime": Date;
  "playMode": string;
  "minTimeBetweenPlays": number;
  "forceInterrupt": boolean;
  "forcePlayTime": number;
  "categoryRotationId": string;
  "screenCategoryId": string;
  "playerGroupId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "scheduleRotationId": string;
  "rotationItemId": string;
  categoryRotation: CategoryRotation;
  screenCategory: ScreenCategory;
  playerGroup: PlayerGroup;
  rotationItem: RotationItem;
  constructor(data?: ScheduleTimeframeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ScheduleTimeframe`.
   */
  public static getModelName() {
    return "ScheduleTimeframe";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ScheduleTimeframe for dynamic purposes.
  **/
  public static factory(data: ScheduleTimeframeInterface): ScheduleTimeframe{
    return new ScheduleTimeframe(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ScheduleTimeframe',
      plural: 'ScheduleTimeframes',
      path: 'ScheduleTimeframes',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "start": {
          name: 'start',
          type: 'Date'
        },
        "end": {
          name: 'end',
          type: 'Date'
        },
        "inverse": {
          name: 'inverse',
          type: 'boolean',
          default: false
        },
        "hasEnd": {
          name: 'hasEnd',
          type: 'boolean',
          default: false
        },
        "repeat": {
          name: 'repeat',
          type: 'boolean',
          default: true
        },
        "repeatDays": {
          name: 'repeatDays',
          type: 'any',
          default: <any>null
        },
        "repeatFrequency": {
          name: 'repeatFrequency',
          type: 'number',
          default: 1
        },
        "specificDates": {
          name: 'specificDates',
          type: 'any',
          default: <any>null
        },
        "specificTime": {
          name: 'specificTime',
          type: 'boolean'
        },
        "startTime": {
          name: 'startTime',
          type: 'Date'
        },
        "endTime": {
          name: 'endTime',
          type: 'Date'
        },
        "playMode": {
          name: 'playMode',
          type: 'string',
          default: 'inTurn'
        },
        "minTimeBetweenPlays": {
          name: 'minTimeBetweenPlays',
          type: 'number',
          default: 0
        },
        "forceInterrupt": {
          name: 'forceInterrupt',
          type: 'boolean',
          default: true
        },
        "forcePlayTime": {
          name: 'forcePlayTime',
          type: 'number',
          default: 1
        },
        "categoryRotationId": {
          name: 'categoryRotationId',
          type: 'string'
        },
        "screenCategoryId": {
          name: 'screenCategoryId',
          type: 'string'
        },
        "playerGroupId": {
          name: 'playerGroupId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "scheduleRotationId": {
          name: 'scheduleRotationId',
          type: 'string'
        },
        "rotationItemId": {
          name: 'rotationItemId',
          type: 'string'
        },
      },
      relations: {
        categoryRotation: {
          name: 'categoryRotation',
          type: 'CategoryRotation',
          model: 'CategoryRotation',
          relationType: 'belongsTo',
                  keyFrom: 'categoryRotationId',
          keyTo: 'id'
        },
        screenCategory: {
          name: 'screenCategory',
          type: 'ScreenCategory',
          model: 'ScreenCategory',
          relationType: 'belongsTo',
                  keyFrom: 'screenCategoryId',
          keyTo: 'id'
        },
        playerGroup: {
          name: 'playerGroup',
          type: 'PlayerGroup',
          model: 'PlayerGroup',
          relationType: 'belongsTo',
                  keyFrom: 'playerGroupId',
          keyTo: 'id'
        },
        rotationItem: {
          name: 'rotationItem',
          type: 'RotationItem',
          model: 'RotationItem',
          relationType: 'belongsTo',
                  keyFrom: 'rotationItemId',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/ScheduleTimeframe.ts